import React from "react";
import root from "window-or-global";
import { BrowserRouter, Route } from "react-router-dom";
import Main from "../components/main";
import Header from "../components/section/header";
import RegisterWelcome from "../controls/register/welcome";
import RegisterPlan from "../controls/register/plan";
import RegisterReview from "../controls/register/review";
import RegisterUserDetails from "../controls/register/user-details";
import RegisterFinal from "../controls/register/final";
import RegisterSuccess from "../controls/register/success";
import RegisterFail from "../controls/register/fail";
import Footer from "../components/section/footer";

import "../style/register.scss";

export default function Register() {
  const [isLoaded, setIsLoaded] = React.useState(false);
  setTimeout(() => {
    setIsLoaded(true);
  }, 1000);


  if (!isLoaded) {
    return (<React.Fragment/>);
  }
  return (<>
    <Main>
      <BrowserRouter basename="/register">
        <Route exact path="/" component={(props) => {
          return (
            <>
              <Header />
              <RegisterWelcome {...props} />
            </>
          );
        }} />
        <Route exact path="/plan" component={(props) => {
          return (
            <>
              <Header />
              <RegisterPlan {...props} />
            </>
          );
        }} />
        <Route exact path="/review" component={(props) => {
          return (
            <>
              <Header />
              <RegisterReview {...props} />
            </>
          );
        }} />
        <Route path="/user" component={(props) => {
          return (
            <>
              <Header />
              <RegisterUserDetails {...props} />
            </>
          );
        }} />
        <Route exact path="/final" component={(props) => {
          return (
            <>
              <Header />
              <RegisterFinal {...props} />
              <Footer />
            </>
          );
        }} />
        <Route exact path="/success" component={(props) => {
          return (
            <>
              <Header />
              <RegisterSuccess {...props} />
            </>
          );
        }} />
        <Route exact path="/fail" component={(props) => {
          return (
            <>
              <Header />
              <RegisterFail {...props} />
            </>
          );
        }} />
      </BrowserRouter>
    </Main>
  </>);
}
